// src/lib/gifts-format.ts
// Czyste funkcje formatujące prezenty/kody — bezpieczne dla klienta
// (bez importów serwerowych: prisma, resend). Współdzielone przez UI i
// logikę serwerową (src/lib/gifts.ts).

export function normalizeGiftEmail(email: string): string {
  return email.trim().toLowerCase();
}

export function sanitizeGiftCode(input: string): string {
  return input.trim().toUpperCase().replace(/[^A-Z0-9-]/g, "");
}

/** Formatuje surowy ciąg na kod w postaci XXXX-XXXX-XXXX (maks. 12 znaków). */
export function formatGiftCode(raw: string): string {
  const cleaned = raw.replace(/[^A-Z0-9]/g, "").slice(0, 12);
  return cleaned.match(/.{1,4}/g)?.join("-") || cleaned;
}

export function normalizeGiftCodeInput(code: string): string {
  return sanitizeGiftCode(code);
}
